import type { ReactNode } from "react";

import { useMediaPreviewContext } from "./MediaPreviewContext";
import { ErrorContainer } from "./styledComponents";

interface IMediaPreviewErrorProps {
    children?: ReactNode;
}

export const MediaPreviewError = ({ children }: IMediaPreviewErrorProps) => {
    const { state } = useMediaPreviewContext();

    if (state.status !== "error") {
        return null;
    }

    return <ErrorContainer>{children}</ErrorContainer>;
};
